const ADMIN_INFO_KEY = "adminInfo";
const ADMIN_STRIPE_ACCOUNT_KEY = "adminStripeAccountDetail";

export const getStoredAdmin = () => {
  try {
    const raw = localStorage.getItem(ADMIN_INFO_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const storeAdminInfo = (admin) => {
  if (!admin || typeof admin !== "object") return;
  localStorage.setItem(ADMIN_INFO_KEY, JSON.stringify(admin));
};

export const clearAdminInfo = () => {
  localStorage.removeItem(ADMIN_INFO_KEY);
  localStorage.removeItem(ADMIN_STRIPE_ACCOUNT_KEY);
};

export const getStoredStripeAccountDetail = () => {
  try {
    const raw = localStorage.getItem(ADMIN_STRIPE_ACCOUNT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const storeStripeAccountDetail = (detail) => {
  if (!detail || typeof detail !== "object") return;
  localStorage.setItem(ADMIN_STRIPE_ACCOUNT_KEY, JSON.stringify(detail));
};

export const clearStripeAccountDetail = () => {
  localStorage.removeItem(ADMIN_STRIPE_ACCOUNT_KEY);
};

export const getAdminDisplayName = (admin) =>
  admin?.name || admin?.full_name || admin?.role_id?.role || "Admin";

export const getAdminRoleLabel = (admin) =>
  admin?.role_id?.role || admin?.role || "Admin";
